import clsx from 'clsx';
import React, { FC, memo, PropsWithChildren } from 'react';
import {
    ModuleTheme,
    ModuleTheme1,
    DisplayOptionsComposition,
    HeightComposition,
} from '~/lib/data-contract';
import styles from './block-wrapper.module.css';
import { useModule } from '~/templates';
import { Container } from '../../container/container.component';

type Props = PropsWithChildren &
    ModuleTheme &
    ModuleTheme1 &
    DisplayOptionsComposition &
    HeightComposition & {
        index?: number;
        className?: string;
        hasGutter?: boolean;
    };

const BlockWrapper: FC<Props> = memo((props) => {
    const {
        hideMobile,
        hideDesktop,
        spacingTop,
        height: initialHeight,
        backgroundColor,
        children,
        className,
        spacingBottom,
        ...rest
    } = props;

    const height = initialHeight ?? 'normal';

    const { index } = useModule();

    return (
        <Container
            spacingTop={index === 0 ? 'none' : spacingTop || 'none'}
            spacingBottom={index === 0 ? 'none' : spacingBottom || 'none'}
            hideMobile={hideMobile}
            hideDesktop={hideDesktop}
            {...rest}
            style={{ backgroundColor }}
        >
            <div className={clsx(styles[`${height}Root`], className)} style={{ backgroundColor }}>
                {children}
            </div>
        </Container>
    );
});

export default BlockWrapper;
